import { render, staticRenderFns } from "./editarCrearAlumno.vue?vue&type=template&id=04c238ca&scoped=true&"
import script from "./editarCrearAlumno.vue?vue&type=script&lang=js&"
export * from "./editarCrearAlumno.vue?vue&type=script&lang=js&"
import style0 from "./editarCrearAlumno.vue?vue&type=style&index=0&id=04c238ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c238ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
